import { styled } from "@mui/material";
import ScrollToTopArrow from "controls/global/scroll-to-top-arrow";
// import SideNav from "controls/global/side-nav";
import React, {
  useRef,
  useState,
} from "react";
import { gaps } from "theme/defaultStyle";
import { useSignatures } from "utils/context/SignaturesContext";
import useTitle from "utils/custom-hooks/useTitle";
import theme from "../../theme/default";
import ManageSignatures from "./components/manage-signature/ManageSignatures";
// import SignatureDefaults from "./components/signature-defaults/SignatureDefaults";


const Container = styled("div")((props) => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "row",
  gap: gaps.large1,
  position: "relative",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

const Content = styled('main')({
  display: "flex",
  flexDirection: "column",
  gap: gaps.medium1,
  flex: 1,
  minWidth: 0,
  width: '100%',
});

const Signatures = () => {
  useTitle("Stewart Connect - Manage Signatures");

  const [scrollToTop, setScrollToTop] = useState(false);
  const manageSignaturesTitleRef = useRef<HTMLElement>();
  // const defaultSignaturesTitleRef = useRef<HTMLElement>();
  const [{ isLoading }] = useSignatures();

  // const navItems = [
  //   { name: "Manage Signatures", childRef: manageSignaturesTitleRef },
  //   { name: "Default Signatures", childRef: defaultSignaturesTitleRef },
  // ];

  const onScrollToTop = () => {
    setScrollToTop(!scrollToTop);
  };

  return (
    <Container>
      {/* <SideNav
        navItems={navItems}
        scrollToTop={scrollToTop}
        includeIconOverflowPadding
      /> */}
      <Content>
        <ManageSignatures titleRef={manageSignaturesTitleRef} />
        <ScrollToTopArrow
          onScrollToTop={onScrollToTop}
          refreshSize={isLoading}
        />
      </Content>
    </Container>
  );
};

export default Signatures;
